import { render, staticRenderFns } from "./liveVideo.vue?vue&type=template&id=33cf7ca4"
import script from "./liveVideo.vue?vue&type=script&lang=js"
export * from "./liveVideo.vue?vue&type=script&lang=js"
import style0 from "./liveVideo.vue?vue&type=style&index=0&id=33cf7ca4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports